@use '@/scss/underscore' as _;

.sidebar {
  width: 248px;
  overflow-y: auto;
  margin-bottom: _.unit(6);
}
